import api from "./api";

const login = params => {
  return api.post(`/go/auth/login`, params);
};

const generateToken = data => {
  return api.post(`/go/livestream/token/generate`, data);
};

const goMe = () => {
  return api.get("/go/core/auth/doctor/me");
};

const getCircleDetailById = circleId => {
  return api.get(`/go/circle/doctor/${circleId}`);
};

const getRoomStreamByRoomId = roomId => {
  return api.get(`/go/circle/doctor/roomstream/${roomId}`);
};

const getRoomConferenceByRoomId = roomId => {
  return api.get(`/go/circle/doctor/roomconference/${roomId}`);
};

const notifyStartStream = data => {
  return api.post("/go/circle/doctor/livestream/notify/start", data);
};

const notifyStopStream = data => {
  return api.post("/go/circle/doctor/livestream/notify/stop", data);
};

const checkMyRoleConferenceRoom = data => {
  return api.post("/go/circle/doctor/role/conference", data);
};

const getListConferenceSchedules = paramsData => {
  const params = new URLSearchParams(paramsData).toString();
  return api.get(`/go/conference/conference_session?${params}`);
};

const getTwlMeetRoom = meetRoomId => {
  return api.get(`/go/meet-rooms/${meetRoomId}`);
};

const getRoomMdtByRoomId = (roomId, params) => {
  return api.get(`/go/core/meet/mdt-rooms/${roomId}`, params);
};

export const detectRoomType = async roomId => {
  const isSuccessfulResponse = res => {
    if (!res) return false;

    if (typeof res === "object" && res.code !== undefined) {
      if (res.code !== 200) return false;
      const d = res.data;
      if (!d) return true;
      if (d.error || d.Error) return false;
      if (d.code && d.code !== 200) return false;
      if (d.status && d.status !== 200 && d.status !== "success") return false;
      return true;
    }

    if (res.status === 200 || res.status === 201) {
      const d = res.data;
      if (!d) return false;
      if (d.error || d.Error) return false;
      if (d.code && d.code !== 200) return false;
      if (d.status && d.status !== 200 && d.status !== "success") return false;
      return true;
    }

    return false;
  };

  // Try MDT (is_public_mdt=0) first
  try {
    const res = await getRoomMdtByRoomId(roomId, { is_public_mdt: 0 });
    if (isSuccessfulResponse(res)) {
      window.localStorage.setItem("type", "mdt");
      return { type: "mdt", res };
    }
  } catch (e) {
    // ignore and try pmdt
  }

  try {
    const res = await getRoomMdtByRoomId(roomId, { is_public_mdt: 1 });
    if (isSuccessfulResponse(res)) {
      window.localStorage.setItem("type", "pmdt");
      return { type: "pmdt", res };
    }
  } catch (e) {
    // nothing
  }

  // If both attempts fail, do not modify localStorage and throw
  throw new Error("Unable to detect room type");
};

const createMeetingMinutes = data => {
  return api.post(`/go/mdt_rooms/concluding`, data);
};

const updateMeetingMinutes = (id, data) => {
  return api.post(`/go/mdt_rooms/concluding/${id}`, data);
};

const showMdtRoomByName = (name, params) => {
  return api.get(
    `/doctor/multidisciplinary-team/${name}/show-name`,
    params,
    null,
    false
  );
};

const showPMdtRoomByName = (name, params) => {
  return api.get(
    `/auth/public-mdt-room/${name}/show-name`,
    params,
    null,
    false
  );
};

const checkPassword = (id, params) => {
  return api.post(`/doctor/multidisciplinary-team/${id}/join`, params);
};

const getMdtDiseases = params => {
  return api.get("/doctor/mdt-room-diseases", params);
};

const getMdtOperationByID = id => {
  return api.get(`/go/mdt_operation/${id}`);
};

const getDoctorsOfWorkspace = (id, params) => {
  return api.get(`/doctor/clinic/${id}/doctors`, params);
};

const getDetailBADT = (id, params) => {
  return api.get(`/v1/medical-records/${id}/master`, params);
};

const mdtConcludingCreate = params => {
  return api.post("/doctor/mdt-room-disease-concluding", params);
};

const pmdtConcludingCreate = params => {
  return api.post("/auth/public-mdt-case-concluding", params);
};

const mdtConcludingUpdate = (id, params) => {
  return api.post(`/doctor/mdt-room-disease-concluding/${id}`, params);
};

const pmdtConcludingUpdate = (id, params) => {
  return api.post(`/auth/public-mdt-case-concluding/${id}`, params);
};

const setEmrDocument = params => {
  if (!params) return;
  return api.post(`/doctor/emr-documents/printing-file`, params);
};

const postUrlImage = url => {
  if (!url) return Promise.reject(new Error("Missing url"));
  return api.post(`/go/core/medicalRecord/file?url=${encodeURIComponent(url)}`);
};

const s3GetRcPresigned = (fileName, headers = null) => {
  return api.post(
    "/core/v1/uploads/s3-get-rc-presigned",
    { fileName },
    headers
  );
};

const mdtDiseaseStatus = (id, params) => {
  return api.post(`/doctor/mdt-room-diseases/${id}/update-status`, params);
};

const pmdtDiseaseStatus = (id, params) => {
  return api.post(`/auth/public-mdt-cases/${id}/status`, params);
};

const printDocument = params => {
  return api.post("/doctor/emr-documents/printing-html", params);
};

const createMdtOperation = params => {
  return api.post(`/go/mdt_operation`, params);
};

const createPMdtOperation = params => {
  return api.post(`/auth/public-mdt-case-operation`, params);
};

const updateMdtOperation = (id, params) => {
  return api.put(`/go/mdt_operation/${id}`, params);
};

const updatePMdtOperation = (id, params) => {
  return api.put(`/auth/public-mdt-case-operation/${id}`, params);
};

const getPMdtDiseases = params => {
  return api.get("/auth/public-mdt-cases", params);
};

const getMdtCheckinMembers = params => {
  return api.get("/doctor/mdt-checkin", params);
};

const getPMdtCheckinMembers = params => {
  return api.get("/auth/public-mdt-checkin", params);
};

const checkIn = params => {
  return api.post("/doctor/mdt-checkin", params);
};

const PMdtCheckIn = params => {
  return api.post("/auth/public-mdt-checkin", params);
};

const doctorAI = params => {
  return api.post("/go/doctor-ai/ask-clinical", params);
};

const getDoctorFeatures = () => {
  return api.get(`/go/core/org/ws-services`);
};

const getWsFeatures = id => {
  return api.get(`/go/core/org/ws-services/${id}`);
};

const getOrgFeatures = id => {
  return api.get(`/go/core/org/org-services/${id}`);
};

const getMeetingRooms = params => {
  return api.get(`/go/meet-rooms/clinic`, params);
};

const getMdtRooms = params => {
  return api.get(`/go/mdt_rooms/v2`, params);
};

const getMdtRoomById = roomId => {
  return api.get(`/go/mdt_rooms/${roomId}`);
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  login,
  generateToken,
  goMe,
  getCircleDetailById,
  getRoomStreamByRoomId,
  getRoomConferenceByRoomId,
  notifyStartStream,
  notifyStopStream,
  checkMyRoleConferenceRoom,
  getListConferenceSchedules,
  getTwlMeetRoom,
  getRoomMdtByRoomId,
  createMeetingMinutes,
  updateMeetingMinutes,
  showMdtRoomByName,
  showPMdtRoomByName,
  getMdtDiseases,
  getPMdtDiseases,
  getMdtOperationByID,
  getDoctorsOfWorkspace,
  getDetailBADT,
  mdtConcludingCreate,
  mdtConcludingUpdate,
  pmdtConcludingCreate,
  pmdtConcludingUpdate,
  setEmrDocument,
  mdtDiseaseStatus,
  pmdtDiseaseStatus,
  printDocument,
  createMdtOperation,
  createPMdtOperation,
  updateMdtOperation,
  updatePMdtOperation,
  getMdtCheckinMembers,
  getPMdtCheckinMembers,
  checkIn,
  PMdtCheckIn,
  checkPassword,
  detectRoomType,
  doctorAI,
  getDoctorFeatures,
  getWsFeatures,
  getOrgFeatures,
  getMeetingRooms,
  getMdtRooms,
  getMdtRoomById,
  postUrlImage,
  s3GetRcPresigned,
};
